import notificationsCenter from "../singleton/NotificationsCenter";

import React from "react";
import { proxiedUrlFor } from "./media-url-utils";
import { FormattedMessage } from "react-intl";
import { permissionMessageLog } from "../react-components/room/PermissionNotifications";
import FormattedPermissionMessage from "../react-components/room/FormattedPermissionMessage";
import { getIntl } from "./intl";
import { ClockFilled, CubeMultipleRegular, Chat16Filled, HandLeftFilled } from "@fluentui/react-icons";
import { LogMessageType, joinedMessages, logJoinedMessages, logMessages } from "./messages";
import { Badge, Button } from "@fluentui/react-components";
import { spawnChatMessage } from "../react-components/chat-message";

const linkStyles = {
  color: "var(--colorBrandBackground)"
};

export default class NotificationMessage {
  constructor() {
    this.mySessionId = null;
    this.exclude = ["stream", "stream-sync"];
  }

  handleMediaNotification(name, message, url) {
    const canSpawnMessages = APP.hubChannel.can("spawn_and_move_media");
    if (canSpawnMessages) {
      const mediaElement = (
        <CubeMultipleRegular style={{ cursor: "pointer" }} onClick={() => spawnChatMessage(url || message)} />
        // <div style={{position: "relative", marginTop: "-3px"}}>
        // <Chat16Filled />
        // <CubeMultipleRegular style={{ cursor: "pointer", position: "absolute", top: "27px", left:"0" }} onClick={() => spawnChatMessage(url || message)} />
        // </div>
      );
      notificationsCenter.withMedia(mediaElement, name, message);
    } else {
      const mediaChat = <Chat16Filled />;

      notificationsCenter.withMedia(mediaChat, name, message);
    }
  }

  handleMediaNotificationUrl(name, url) {
    const canSpawnMessages = APP.hubChannel.can("spawn_and_move_media");
    if (canSpawnMessages) {
      const mediaElement = <CubeMultipleRegular style={{ cursor: "pointer" }} onClick={() => spawnChatMessage(url)} />;

      // const mediaElement = (
      //   <div style={{position: "relative", marginTop: "-3px"}}>
      //     <Chat16Filled />
      //     <CubeMultipleRegular style={{ cursor: "pointer", top: "27px", left:"0", position: "absolute" }} onClick={() => spawnChatMessage(url)} />
      //   </div>
      // );
      notificationsCenter.withMedia(mediaElement, name);
    } else {
      const mediaChat = <Chat16Filled />;

      notificationsCenter.withMedia(mediaChat, name);
    }
  }

  handleImageNotification(name, url) {
    const canSpawnMessages = APP.hubChannel.can("spawn_and_move_media");
    const img = new Image();
    img.src = proxiedUrlFor(url);

    img.onload = () => {
      const imgWidth = img.naturalWidth;
      const imgHeight = img.naturalHeight;

      // Dynamically set the dimensions or styles for the notification content
      const messageWithImage = (
        <a
          style={{ ...linkStyles, display: "block", maxWidth: imgWidth, maxHeight: imgHeight }}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={img.src} style={{ maxWidth: "100%", height: "auto" }} />
        </a>
      );

      if (canSpawnMessages) {
        const mediaElement = (
          <CubeMultipleRegular style={{ cursor: "pointer" }} onClick={() => spawnChatMessage(url)} />
        );
        notificationsCenter.withMedia(mediaElement, name, messageWithImage);
      } else {
        notificationsCenter.info(name, messageWithImage);
      }
    };
  }

  async pushNotification(entry) {
    const clientId = NAF.clientId;
    const isMod = APP.hubChannel.presence?.state[clientId]?.metas[0].roles["owner"];
    const mySessionId = this.mySessionId;
    const name = entry.name;

    if (entry.type === "chat" && entry.body?.privacyType === "private-chat" && entry.body?.receiver === mySessionId) {
      const message = entry.body.message;
      this.handleMediaNotification(name, message);

      return;
    }
    const intl = getIntl();
    let media;
    let message;

    if (this.exclude.includes(entry.type)) {
      return;
    }

    switch (entry.type) {
      case "chat": {
        message = entry.body;
        if (entry.sessionId !== mySessionId) {
          this.handleMediaNotification(name, message);
        }

        break;
      }
      case "image": {
        const url = entry?.body?.src;
        this.handleImageNotification(name, url);

        break;
      }
      case "photo": {
        const url = entry?.body?.src;
        const title = (
          <span>
            <FormattedMessage
              id="photo-message.body"
              defaultMessage="{name}  took a <a> photo</a>."
              values={{
                name: entry.name,
                // eslint-disable-next-line react/display-name
                a: chunks => (
                  <a style={linkStyles} href={url} target="_blank" rel="noopener noreferrer">
                    {chunks}
                  </a>
                )
              }}
            />
          </span>
        );
        this.handleImageNotification(title, url);
        break;
      }
      case "video": {
        const url = entry?.body?.src;
        const title = (
          <span>
            <FormattedMessage
              id="video-message.body"
              defaultMessage="{name} took a <a>video</a>."
              values={{
                name: <b>{name}</b>,
                // eslint-disable-next-line react/display-name
                a: chunks => (
                  <b>
                    <a style={linkStyles} href={url} target="_blank" rel="noreferrer">
                      {chunks}
                    </a>
                  </b>
                )
              }}
            />
          </span>
        );
        this.handleMediaNotificationUrl(title, url);
        break;
      }
      case "object": {
        const url = entry?.body?.src;
        const title = (
          <span>
            <FormattedMessage
              id="object-message.body"
              defaultMessage="{name} placed an <a>asset</a>"
              values={{
                name: <b>{name}</b>,
                // eslint-disable-next-line react/display-name
                a: chunks => (
                  <b>
                    <a style={linkStyles} href={url} target="_blank" rel="noreferrer">
                      {chunks}
                    </a>
                  </b>
                )
              }}
            />
          </span>
        );
        this.handleMediaNotificationUrl(title, url);
        break;
      }
      case "permission":
        if (!isMod || entry.sessionId !== clientId) {
          const permission = permissionMessageLog({
            status: entry?.body?.status,
            permission: entry?.body?.permission,
            isMod
          });
          notificationsCenter.info(permission);
        }
        break; // Add the missing break statement

      case "join":
        media = <ClockFilled color="#EAA300" />;

        message = intl.formatMessage(logJoinedMessages[entry.presence], { name: "" });

        notificationsCenter.withMedia(media, name, message);
        break;
      case "entered":
        message = intl.formatMessage(logMessages[LogMessageType.enteredVerse]);

        notificationsCenter.success(name, message);
        break;
      case "leave":
        media = <Badge size="small" color="danger" />;

        message = intl.formatMessage(logMessages[LogMessageType.leaveVerse]);

        notificationsCenter.withMedia(media, name, message);
        break;
      case LogMessageType.handRaised: {
        const media = <HandLeftFilled />;
        const message = intl.formatMessage(logMessages[LogMessageType.handRaised]);

        notificationsCenter.withMedia(media, name, message);
        break;
      }
      case "change_scene":
      case "change_hub":
        break;
      default:
        if (entry.sessionId === clientId && entry.type === LogMessageType.displayNameChanged) {
          break;
        }

        message = <FormattedPermissionMessage entry={entry} />;
        notificationsCenter.info(message, null);
        break;
    }
  }
}

// function ResizableToast({ title, message, media }) {
//   const ref = useRef();

//   const intl = getIntl();

//   const notificationTitle = logMessages[title]
//     ? intl.formatMessage(logMessages[title], { defaultMessage: title })
//     : title || "Info";

//   const dismissButton = <Dismiss20Filled color="white" />;

//   useEffect(() => {
//     const resizeObserver = new ResizeObserver(() => {
//       if (ref.current) {
//         console.log("observed height");
//         // Force toaster to adjust to new height if necessary
//         ref.current.style.height = 'auto';
//       }
//     });
//     if (ref.current) resizeObserver.observe(ref.current);

//     return () => resizeObserver.disconnect();
//   }, []);

//   return (
//     <div ref={ref}>
//       <Toast>
//         <ToastTitle>{title}</ToastTitle>
//         {message && <ToastBody>{message}</ToastBody>}
//       </Toast>
//     </div>
//   );
// }
